import { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { matchPath, useLocation } from 'react-router-dom'

import { UserStore } from 'stores'

const routesNotToScroll = ['/pin', '/post', '/members-and-teams', '/topics/']
const routesNotToScrollWithWorkspace = ['/workspace/:panelId/post/:provider/:postId']

const shouldScroll = (route, previousRoute) => {
  const isRouteWithWorkspaceInList = routesNotToScrollWithWorkspace.some(
    notScrollRoute =>
      matchPath(route, { path: notScrollRoute, exact: true }) ||
      matchPath(previousRoute, { path: notScrollRoute, exact: true })
  )
  const isRouteInList = routesNotToScroll.some(
    notScrollRoute => route.startsWith(notScrollRoute) || previousRoute?.startsWith(notScrollRoute)
  )

  return !isRouteInList && !isRouteWithWorkspaceInList
}

function RouteChangeMiddleware({ children }) {
  const [, setPreviousRoute] = useState('')
  const location = useLocation()

  useEffect(() => {
    const _hsq = (window._hsq = window._hsq || [])
    _hsq.push(['setPath', location.pathname])
    _hsq.push(['trackPageView'])

    UserStore.shouldReloadAfterRouterChange && window.location.reload()
    const currentRoute = location.pathname
    setPreviousRoute(prevState => {
      shouldScroll(currentRoute, prevState) && window.scrollTo(0, 0)
      return location.pathname
    })
  }, [location.pathname])

  return children
}

export default observer(RouteChangeMiddleware)
